import React from 'react';
import FacilipayOney from '@components/molecules/products/product-details/components/product-installment/modal-payment-installment/components/facilipay-oney';
import Splitit from '@components/molecules/products/product-details/components/product-installment/modal-payment-installment/components/splitit';
import Klarna from '@components/molecules/products/product-details/components/product-installment/modal-payment-installment/components/klarna';
import { Price } from '@interfaces/models/price';
import styles from './modal-payment-installment.module.scss';
import Affirm from './components/affirm';

interface ModalPaymentInstallmentProps {
  paymentName: string;
  price?: Price;
}

const ModalPaymentInstallment: React.FC<ModalPaymentInstallmentProps> = ({ paymentName, price }) => {
  const isPayment = (payment: string): boolean => {
    return paymentName === payment;
  };

  return (
    <div className={styles.modalPayment}>
      {isPayment('facilypay_oney') && <FacilipayOney />}
      {isPayment('splitit') && <Splitit />}
      {isPayment('klarna') && <Klarna />}
      {isPayment('affirm') && <Affirm price={price} />}
    </div>
  );
};

export default ModalPaymentInstallment;
